module.exports = __webpack_public_path__ + "img/pr-18.e124bd1c.png";